module.exports = __webpack_public_path__ + "img/lxsPt.e440521a.jpg";